import * as React from 'react';
import { Select, Row, Col, Button } from 'antd';
import '../../../css/UploadProfileContentThree.scss';
import strings from '../../../eyeguide-localization/profile/strings.profile.bulkupload';
// import Constants from '../../common/constants';
// import Util from '../../common/utils';

const REQUIREDKEYS = [   
    strings.lsFirstNameTxt, 
    strings.lsLastNameTxt, 
    strings.lsDOBTxt,
    strings.lsGenderTxt,
    [strings.lsEmailTxt.toLowerCase(), strings.lsPhoneTxt.toLowerCase()]
];

const NODATAMSG = 'Not Specified';
const INVALIDDATEFORMATMSG = 'Invalid Date Format';
const YYYYMMDD = /^\d{4}\s*\/\s*\d{1,2}\s*\/\s*\d{1,2}$/;
const YYYYMMDD_SEPERATOR_2 = /^\d{4}\s*-\s*\d{1,2}\s*-\s*\d{1,2}$/;

interface IUploadProfileContentThreeProps {
    handleNextClick: any;
    handlePrevClick: any;
    csvRows: any;
    hasHeader: any;
    FirstNameCol: string;
    MiddleNameCol: string;
    LastNameCol: string;
    IDCol: string;
    DOBCol: string;
    GenderCol: string;
    SportCol: string;
    LevelCol: string;
    EmailCol: string;
    PhoneCol: string;
    mappedColumns: Array<any>;
    selectedColumns: any;
    nextStepDisabled: boolean;
    validateGender: any;
    validateLevel: any;
    validateSport: any;
    validateEmail: any;
    validatePhone: any;
}

/**
 * State definition
 */
interface IUploadProfileContentThreeState {
    
    mappedColData: Array<any>;
    columnData: Array<any>;
    columnHeaders: Array<any>;
    current: number;
    selectedColumns: any;
    FirstNameCol: string;
    MiddleNameCol: string;
    LastNameCol: string;
    IDCol: string;
    DOBCol: string;
    GenderCol: string;
    SportCol: string;
    LevelCol: string;
    EmailCol: string;
    PhoneCol: string;
    loading: boolean;
    nextStepDisabled: boolean;
}

const columns = [
    strings.lsFirstNameTxt, strings.lsMiddleNameTxt, strings.lsLastNameTxt,
    strings.lsIDTxt, strings.lsDOBTxt, strings.lsGenderTxt, strings.lsSportTxt,
    strings.lsLevelTxt, strings.lsEmailTxt, strings.lsPhoneTxt
];

export default class UploadContentThree extends React.Component<IUploadProfileContentThreeProps
    , IUploadProfileContentThreeState> {

    constructor(props: IUploadProfileContentThreeProps) {
        super(props); 
        this.state = {
            mappedColData: [],
            columnData: [],
            columnHeaders: [],
            current: 2,
            selectedColumns: {},
            FirstNameCol: this.props.FirstNameCol,
            MiddleNameCol: this.props.MiddleNameCol,
            LastNameCol: this.props.LastNameCol,
            IDCol: this.props.IDCol,
            DOBCol: this.props.DOBCol,
            GenderCol: this.props.GenderCol,
            SportCol: this.props.SportCol,
            LevelCol: this.props.LevelCol,
            EmailCol: this.props.EmailCol,
            PhoneCol: this.props.PhoneCol,
            loading: false,
            nextStepDisabled: this.props.nextStepDisabled
        };
        this.getMappedColData = this.getMappedColData.bind(this);
        this.setMappedColumn = this.setMappedColumn.bind(this);
    }

    componentDidMount() {
        if (this.props.hasHeader) {
            let mappedColData: any = [...this.props.mappedColumns];
            let selectedColumns: any = {...this.props.selectedColumns};
            // let headers = this.getCsvHeaders();
            // console.log('headers', headers);
            if (this.props.nextStepDisabled) {
                this.props.csvRows[0].forEach((row, i) => {

                    let index1 = -1, index2 = -1;
                    for ( let indx = 0; indx < columns.length; indx++ ) {
                        if ( columns[indx].toLowerCase() === row.toLowerCase()) {
                            index1 = indx;
                        }
                    }

                    for ( let indx = 0; indx < mappedColData.length; indx++ ) {
                        if (mappedColData[indx].name.toLowerCase() === row.toLowerCase()) { 
                            index2 = indx;
                        }
                    }

                    /*let index1 = columns.findIndex(
                        col => col.toLowerCase() === row.toLowerCase()
                    );
                    let index2 = mappedColData.findIndex(
                        col => col.name.toLowerCase() === row.toLowerCase()
                    );*/
                    if (index1 > -1 && index2 === -1) {
                        mappedColData.push({index: i, name: columns[index1]});
                        selectedColumns[columns[index1].split(' ').join('').toLowerCase()] = row;
                    }
                });
            }
            console.log('mapped columns', mappedColData);
            console.log('selected columns', selectedColumns);
            this.setState(
                {mappedColData, selectedColumns},
                () => {
                    if (this.props.nextStepDisabled) {
                        this.setState({
                            nextStepDisabled: this.validateNextStep()
                        });
                    }
                }
            );
        }
    }

    render() {
        console.log('props.csvRows', this.props.csvRows);
        console.log('state.mappedColData', this.state.mappedColData);
        let headers = this.getCsvHeaders();
        console.log('headers', headers);

        return (             
            <div className="UploadProfileContentThree">
                {this.state.loading ? <div>Loading...</div> : <div>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                    <Col xs={8} sm={8} md={5} lg={3} xl={5} className="labelFrame">
                        <div className="label">
                            <span>   {strings.lsFirstNameTxt}      
                            <span className="labelReq"> * </span>
                            :</span>
                        </div>
                    </Col>                    
                    <Col xs={10} sm={10} md={12} lg={6} xl={11}>
                        <Select 
                            className="fill"
                            placeholder="Select Column"
                            value={this.state.selectedColumns.firstname}
                            onChange={e => this.handleOptionChange(e, strings.lsFirstNameTxt)}
                        >
                            {
                                headers.map((item, i) => 
                                    <option id={item.index} value={item.index} key={item.index}> 
                                        {item.name} 
                                    </option> )
                            }
                        </Select>
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                    <Col xs={8} sm={8} md={5} lg={3} xl={5} className="labelFrame">
                        <div className="label">
                            <span>   {strings.lsMiddleNameTxt}                            
                            :</span>
                        </div>
                    </Col>
                    <Col xs={10} sm={10} md={12} lg={6} xl={11}>
                        <Select 
                            className="fill"
                            placeholder="Select Column"
                            value={this.state.selectedColumns.middlename}
                            onChange={e => this.handleOptionChange(e, strings.lsMiddleNameTxt)}
                        >
                            {
                                headers.map((item, i) =>  
                                    <option id={item.index} value={item.index} key={item.index}> 
                                        {item.name} 
                                    </option> )
                            }
                        </Select>
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                    <Col xs={8} sm={8} md={5} lg={3} xl={5} className="labelFrame">
                        <div className="label">
                            <span>   {strings.lsLastNameTxt}      
                            <span className="labelReq"> * </span>
                            :</span>
                        </div>
                    </Col>
                    <Col xs={10} sm={10} md={12} lg={6} xl={11}>
                        <Select 
                            className="fill"
                            placeholder="Select Column"
                            value={this.state.selectedColumns.lastname}
                            onChange={e => this.handleOptionChange(e, strings.lsLastNameTxt)}
                        >
                            {
                                headers.map((item, i) =>  
                                    <option id={item.index} value={item.index} key={item.index}> 
                                        {item.name} 
                                    </option> )
                            }
                        </Select>
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                    <Col xs={8} sm={8} md={5} lg={3} xl={5} className="labelFrame">
                        <div className="label">
                            <span>   {strings.lsIDTxt}                            
                            :</span>
                        </div>
                    </Col>
                    <Col xs={10} sm={10} md={12} lg={6} xl={11}>
                        <Select 
                           className="fill"
                           placeholder="Select Column"
                           value={this.state.selectedColumns.id}
                           onChange={e => this.handleOptionChange(e, strings.lsIDTxt)}
                        >
                            {
                                headers.map((item, i) =>  
                                    <option id={item.index} value={item.index} key={item.index}> 
                                        {item.name} 
                                    </option> )
                            }
                        </Select>
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                    <Col xs={8} sm={8} md={5} lg={3} xl={5} className="labelFrame">
                        <div className="label">
                            <span>   {strings.lsDOBTxt}      
                            <span className="labelReq"> * </span>
                            :</span>
                        </div>
                    </Col>
                    <Col xs={10} sm={10} md={12} lg={6} xl={11}>
                        <Select 
                            className="fill"
                            placeholder="Select Column"
                            value={this.state.selectedColumns.dateofbirth}
                            onChange={e => this.handleOptionChange(e, strings.lsDOBTxt)}
                        >
                            {
                                headers.map((item, i) =>  
                                    <option id={item.index} value={item.index} key={item.index}> 
                                        {item.name} 
                                    </option> )
                            }
                        </Select>
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                    <Col xs={8} sm={8} md={5} lg={3} xl={5} className="labelFrame">
                        <div className="label">
                            <span>   {strings.lsGenderTxt}      
                            <span className="labelReq"> * </span>
                            :</span>
                        </div>
                    </Col>
                    <Col xs={10} sm={10} md={12} lg={6} xl={11}>
                        <Select 
                            className="fill"
                            placeholder="Select Column"
                            value={this.state.selectedColumns.gender}
                            onChange={e => this.handleOptionChange(e, strings.lsGenderTxt)}
                        >
                            {
                                headers.map((item, i) =>  
                                    <option id={item.index} value={item.index} key={item.index}> 
                                        {item.name} 
                                    </option> )
                            }
                        </Select>
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                    <Col xs={8} sm={8} md={5} lg={3} xl={5} className="labelFrame">
                        <div className="label">
                            <span>   {strings.lsEmailTxt}                            
                            :</span>
                        </div>
                    </Col>
                    <Col xs={10} sm={10} md={12} lg={6} xl={11}>
                        <Select 
                            className="fill"
                            placeholder="Select Column"
                            value={this.state.selectedColumns.email}
                            onChange={e => this.handleOptionChange(e, strings.lsEmailTxt)}
                        >
                            {
                                headers.map((item, i) =>  
                                    <option id={item.index} value={item.index} key={item.index}> 
                                        {item.name} 
                                    </option> )
                            }
                        </Select>
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                    <Col xs={8} sm={8} md={5} lg={3} xl={5} className="labelFrame">
                        <div className="label">
                            <span>   {strings.lsPhoneTxt}                            
                            :</span>
                        </div>
                    </Col>
                    <Col xs={10} sm={10} md={12} lg={6} xl={11}>
                        <Select 
                            className="fill"
                            placeholder="Select Column"
                            value={this.state.selectedColumns.phone}
                            onChange={e => this.handleOptionChange(e, strings.lsPhoneTxt)}
                        >
                            {
                                headers.map((item, i) =>  
                                    <option id={item.index} value={item.index} key={item.index}> 
                                        {item.name} 
                                    </option> )
                            }
                        </Select>
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                    <Col xs={8} sm={8} md={5} lg={3} xl={5} className="labelFrame">
                        <div className="label">
                            <span>   {strings.lsSportTxt}                            
                            :</span>
                        </div>
                    </Col>
                    <Col xs={10} sm={10} md={12} lg={6} xl={11}>
                        <Select 
                            className="fill"
                            placeholder="Select Column"
                            value={this.state.selectedColumns.sport}
                            onChange={e => this.handleOptionChange(e, strings.lsSportTxt)}
                        >
                            {
                                headers.map((item, i) =>  
                                    <option id={item.index} value={item.index} key={item.index}> 
                                        {item.name} 
                                    </option> )
                            }
                        </Select>
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                    <Col xs={8} sm={8} md={5} lg={3} xl={5} className="labelFrame">
                        <div className="label">
                            <span>   {strings.lsLevelTxt}                            
                            :</span>
                        </div>
                    </Col>
                    <Col xs={10} sm={10} md={12} lg={6} xl={11}>
                        <Select 
                            className="fill"
                            placeholder="Select Column"
                            value={this.state.selectedColumns.level}
                            onChange={e => this.handleOptionChange(e, strings.lsLevelTxt)}
                        >
                            {
                                headers.map((item, i) =>  
                                    <option id={item.index} value={item.index} key={item.index}> 
                                        {item.name} 
                                    </option> )
                            }
                        </Select>
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>

                <Row>
                    <Col span={10} style={{padding: '10px', width: '48%'}}>
                        <div className="buttonRight"> 
                            <Button 
                                    onClick={e => this.props.handlePrevClick(2)}
                                    type="danger" 
                                    style={{width: '100%'}}
                            > 
                            {'Previous'} 
                            </Button> 
                        </div>
                    </Col>
                    <Col span={10} style={{padding: '10px'}}>
                        <div className="buttonLeft">
                            <Button 
                                onClick={e => {                                
                                    this.props.handleNextClick(
                                        {
                                            data : this.getMappedColData(),
                                            mappedColumns: this.state.mappedColData,
                                            selectedColumns: this.state.selectedColumns,
                                            FirstNameCol: this.state.selectedColumns.firstname,
                                            MiddleNameCol: this.state.selectedColumns.middlename,
                                            LastNameCol: this.state.selectedColumns.lastname,
                                            IDCol: this.state.selectedColumns.id,
                                            DOBCol: this.state.selectedColumns.dateofbirth,
                                            GenderCol: this.state.selectedColumns.gender,
                                            SportCol: this.state.selectedColumns.sport,
                                            LevelCol: this.state.selectedColumns.level,
                                            EmailCol: this.state.selectedColumns.email,
                                            PhoneCol: this.state.selectedColumns.phone,
                                            loading: this.state.loading,
                                            nextStepDisabled: this.state.nextStepDisabled,
                                            columnHeaders: this.getCsvHeaders(),
                                            hasHeader: this.props.hasHeader,
                                            getDob: this.getDob
                                        },
                                        3
                                    );
                                }}     
                                type="primary" 
                                style={{width: '100%'}}
                                disabled={this.state.nextStepDisabled}
                            > 
                            {'Next'} 
                            </Button>  
                        </div>
                    </Col>
                </Row> </div> }
            </div>                            
        );
    }

    private handleOptionChange(e: any, key: string) {
        let headers = this.getCsvHeaders();
        let mappedColData = this.setMappedColumn({name: key, index: e});
        let name = e !== -1 ? headers[e + 1].name : 'Select Column';
        let selectedColumns = {...this.state.selectedColumns};
        selectedColumns[key.split(' ').join(''). toLowerCase()] = name;
        this.setState(
            {mappedColData, selectedColumns},
            () => this.setState({
                nextStepDisabled: this.validateNextStep()
            })
        );
    }

    private validateNextStep() {
        let reqKeys = REQUIREDKEYS.filter(key => { 
            let data = this.state.mappedColData.filter(element => {
                return element.index !== -1 && (Array.isArray(key) ? 
                    key.indexOf(element.name.toLowerCase()) !== -1 
                    : key.toLowerCase() === element.name.toLowerCase());
                });
            // if (data !== undefined && data != null && data.length > 0) {
            //     if ( data[0].index !== -1 ) {
            //         return true;
            //     }
            // }
            return data.length !== 0;
        });
        console.log('reqKeys: ', reqKeys.length !== REQUIREDKEYS.length);
        return reqKeys.length !== REQUIREDKEYS.length;
    }

    private setMappedColumn = (param) => {
        let mappedColData = [...this.state.mappedColData];
        let index = this.state.mappedColData.indexOf(
            mappedColData.filter(element => param.name === element.name)[0]
        );
        if (index !== -1) {        
            mappedColData[index] = param;       
        } else {
            mappedColData.push(param);
        }
        console.log('setMappedColumn: ', mappedColData);
        return mappedColData;
        // this.setState(
        //     {mappedColData},
        //     () => this.setState({
        //         nextStepDisabled: this.validateNextStep()
        //     })
        // );
        // return param.index;
    }

    private getCsvHeaders() {
        let items: Array<any> = []; 
        let indx = 0;
        let csvRows = this.props.csvRows.filter(row => {
            let cols = row.filter(col => col.trim().length > 0);
            return cols.length > 0 ? row : '' ; })[0];

        console.log('csvRows: ', csvRows); 
        items.push( {index: -1, name: 'Select Column'} );

        if (this.props.hasHeader) {
            csvRows.forEach( element => {            
                items.push( {index: indx++, name: element} );
            });
        } else {
            while (csvRows.length - indx) {
                items.push( {index: indx, name: 'Column ' + (indx + 1)} ); 
                ++indx;       
            }
        }
        // this.setState({columnHeaders: items});
        return items;
    }

    /**
     * Displays and sets the data fetched from csv uploaded
     * @param data Data fetched from csv as array to upload
     */
    
    private getMappedColData() {           

        this.setState({loading: true});
        let colData = this.buildMappedData();        
        console.log('buildData: ', colData);        
        this.setState({columnData: colData, loading: false});        
        return colData;
    }
        
    /**
     * This function builds the data required by the Table component to display the profiles     
     */
    
    private buildMappedData() {
        let columnData: Array<any> = [];
        if (this.state.mappedColData !== null) {
            let i = 0;

            let csvRows = this.props.csvRows.filter(row => {
                let cols = row.filter(col => col.trim().length > 0);
                return cols.length > 0 ? row : '' ; });

            csvRows.forEach( (element: any) => {
                if ( !(i === 0 && this.props.hasHeader) // skip header
                    && !(element.length === 1 && element[0].trim().length === 0)) {

                    let data = {
                        index: this.props.hasHeader ? i : i + 1,

                        playerid: '',

                        firstname: this.getColumnData(element, strings.lsFirstNameTxt),

                        middlename: this.getColumnData(element, strings.lsMiddleNameTxt),

                        lastname: this.getColumnData(element, strings.lsLastNameTxt),

                        id: this.getColumnData(element, strings.lsIDTxt),

                        dob: this.getDob(this.getColumnData(element, strings.lsDOBTxt)),

                        gender: this.props.validateGender(this.getColumnData(element, strings.lsGenderTxt)),

                        sport: this.props.validateSport(this.getColumnData(element, strings.lsSportTxt)),

                        level: this.props.validateLevel(this.getColumnData(element, strings.lsLevelTxt)),

                        email: this.props.validateEmail(this.getColumnData(element, strings.lsEmailTxt)),

                        phone: this.props.validatePhone(this.getColumnData(element, strings.lsPhoneTxt)),
                        
                        organization: this.getColumnData(element, 'Organization')
                    };
                    columnData.push(data);
                }
                i++;
            }); 
        }
        console.log('buildMappedData: ', columnData);
        return columnData;
    }

    /**
     * Validates and returns the date of birth provided in CSV data
     * @param dob Date of Birth
     */
    private getDob = (dob: any) => {

        if (dob === null || dob === undefined || 
            dob.toString().trim().length === 0) {

            return NODATAMSG;
        }

        if (isNaN(parseInt(dob, undefined))) {
            return INVALIDDATEFORMATMSG;
        }

        let yearReversed = false;
        if (YYYYMMDD_SEPERATOR_2.test(dob.trim())) { // YYYY-MM-DD format
            yearReversed = true;
            console.log('YYYY-MM-DD format.');
        }

        let dateValues: any = yearReversed ? dob.split('-') : dob.split('/');
        dateValues = dateValues.map(element => { return String(element).trim(); });
        console.log('dateValues: ', dateValues);
        if (dateValues !== undefined && dateValues !== null && dateValues.length === 3) {

            let year = yearReversed ? dateValues[0] : dateValues[2];
            
            dob = '';
            for (let i = yearReversed ? 1 : 0 ; i <= 2; i++) {
                if (!yearReversed && i === (dateValues.length - 1)) {
                    continue;
                }

                let str = '0';
                if (dateValues[i].length < 2) {
                    dateValues[i] = str.concat(dateValues[i]);
                }
            }
            
            if (year.length === 2) {
                let Century: any = (new Date().getFullYear() / 100);
                Century = parseInt(Century, undefined);
                // Math.floor(Century);
                let currentYear: any = new Date().getUTCFullYear().toString().substr(2);
                parseInt(currentYear, undefined);
                let enteredYear: any = parseInt(year, undefined); 
                if (enteredYear > currentYear) {
                    Century -= 1;
                }

                year  = (Century.toString()).concat(year);
                console.log(year);
                if (yearReversed) {
                    dateValues[0] = year;
                } else {
                    dateValues[2] = year;
                }
            }
            
            let month = yearReversed ? dateValues[1] : dateValues[0];
            let day = yearReversed ? dateValues[2] : dateValues[1];
            dob = month.concat('/' + day).concat('/' + year);            
        }
        console.log(dob);
        let isValid: any =  this.validateDate(dob);
        if (isValid.toString() !== INVALIDDATEFORMATMSG && isValid <= new Date()) {
            return dob;
        }

        return INVALIDDATEFORMATMSG;
    }

    /**
     * Validates the date contained in csv file
     * @param date Date to be validated
     */
    private validateDate(date: string) {
        
        if (date.trim().length !== 10) {
            return INVALIDDATEFORMATMSG;
        }
        let dob = date;
        let yearReversed = false;        
        if (YYYYMMDD.test(dob.trim())) { // YYYY/MM/DD format
            yearReversed = true;
        }
        let dateValues: string[] = dob.split('/');
        let year = yearReversed ? dateValues[0] : dateValues[2];
        let month = yearReversed ? dateValues[1] : dateValues[0];
        let day = yearReversed ? dateValues[2] : dateValues[1];
        console.log('year: ', year);
        console.log('month: ', month);
        console.log('day: ', day);
        if (dateValues.length === 3) {
            if (month.toString().trim().length === 2 && 
                day.toString().trim().length === 2 && 
                year.toString().trim().length === 4 && 
                year.toString().trim() !== '0000') {
                    let dateTobeChecked = month.concat('/' + day).concat('/' + year);
                    console.log('dateTobeChecked: ', dateTobeChecked);
                    if (!this.validateDayOfDate(parseInt(day, 10), 
                                                parseInt(month, 10) - 1, 
                                                parseInt(year, 10))) {
                        return INVALIDDATEFORMATMSG;
                    }                    
                    let formattedDate = new Date(dateTobeChecked);
                    return formattedDate;
                }
        }
        return INVALIDDATEFORMATMSG;
    }
     
    /**
     * Validates the Date part of the date provided in csv file
     * @param day 
     * @param month 
     * @param year 
     */
    private validateDayOfDate(day: number, month: number, year: number) {
        var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];
        // Adjust for leap years
        if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
            monthLength[1] = 29;
        }
        // Check the range of the day
        return day > 0 && day <= monthLength[month];
    }

    private getColumnData(element: any, key: string) {
        console.log('getcolumndata', element, key);
        return (this.state.mappedColData.indexOf(this.state.mappedColData.filter(item => { 
                return item.name === key  && item.index < element.length; })[0]) !== -1 ? 
                        this.state.mappedColData.find(item => { 
                                return item.name === key; }).index !== -1 ? 
                                    element[this.state.mappedColData.find(item => { 
                                    return item.name === key; }).index].toString().trim()
                    : '' : '');
    }
}


// WEBPACK FOOTER //
// ./src/components/profile/uploadprofilesteps/UploadProfileContentThree.tsx